module.exports = "<a href=\"http://theseeker.nyethompson.co.uk\"><img src=\"assets/ankh-sym-shadow.png\" alt=\"Home\" class=\"reflect\"></a>\r\n<div *ngIf=\"visionLocation == null; else notEmpty\">\r\n  <p>Seeking...</p>\r\n</div>\r\n<ng-template #notEmpty>\r\n  <p>Input: Visual data packet acquired<br>\r\n\t  GeoSource: <span class=\"overviewlg\">{{visionLocation}}</span> \r\n\t</p>\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/vision/vision-location/vision-location.component.html
// module id = ./src/app/vision/vision-location/vision-location.component.html
// module chunks = main